<template>
  <div>
    <!-- 存储概览 -->
    <div class="storage-overview">
      <div class="info-section">
        <!-- 左侧信息区 -->
        <div class="info-left">
          <div class="card-header">
            <a-select default-value="上海科技有限公司" style="width: 200px" size="small">
              <a-select-option value="上海科技有限公司">上海科技有限公司</a-select-option>
            </a-select>
          </div>
          <div class="info-row">
            <div class="info-group">
              <div class="info-label">当前套餐</div>
              <div class="info-value">基础套餐 100GB</div>
            </div>

          </div>

          <div class="info-row">

            <div class="info-group">
              <div class="info-label">到期时间</div>
              <div class="info-value">2025-12-31</div>
            </div>
          </div>

        </div>

        <!-- 右侧图表区 -->
        <div class="storage-right">
          <a-progress
            type="circle"
            :percent="65"
            :width="150"
            :stroke-width="8"
            stroke-color="#1890ff"
            trail-color="#e0e0e0"
          />
          <div class="usage-text">已用 65GB / 总计 100GB</div>
        </div>
      </div>
    </div>

    <!-- 使用详情 -->
    <div class="storage-overview" style="margin-top: 40px">
      <UsageDetails />
    </div>

    <!-- 存储警告提示 -->
    <div class="storage-alert" style="margin-top: 40px">
      <div class="alert-content">
        <div class="alert-text" style="display: flex; justify-content: space-between; align-items: center">
          <a-icon type="exclamation-circle" class="alert-icon" />
          <div class="alert-title">
            存储空间即将用完
            <div class="alert-desc">您的存储空间已使用 65%，建议购买扩容包以避免存储不足</div>
          </div>
        </div>
        <a-button type="primary" >购买扩容包</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import UsageDetails from './components/UsageDetails.vue'

export default {
  name: 'StorageOverview',
  components: { UsageDetails },
  data() {
    return {}
  },
}
</script>

<style scoped>
.storage-alert {
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.alert-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alert-icon {
  color: #ffa940;
  font-size: 18px;
  margin-right: 12px;
  margin-top: 2px;
}

.alert-title {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 1.5;
  margin-bottom: 2px;
}

.alert-desc {
  font-size: 12px !important;
  color: #666666 !important;
  font-weight: 100 !important;

  line-height: 1.5;
}

.storage-overview {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.card-header {
  margin-bottom: 20px;
}

.company-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  line-height: 1.4;
  margin-bottom: 24px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
}

.company-name-container:hover {
  background-color: #f5f5f5;
}

.info-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-left {
  flex: 1;
  min-width: 0;
}

.info-row {
  display: flex;
  margin-bottom: 2px;
  width: 230px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.info-group {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.info-label {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
}

.info-value {
  font-size: 14px;  color: #000000;
  line-height: 1.5;
}

.storage-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 16px;
}

.storage-left {
  display: flex;
  gap: 20px;
  background: #eff6ff;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
}

.storage-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.storage-label {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
}

.storage-value {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 1.2;
}

.storage-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  justify-content: center;
  margin-right: 100px;
}

.usage-text {
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  text-align: center;
}

@media (max-width: 768px) {
  .storage-overview {
    padding: 16px;
    margin: 16px;
  }

  .info-row {
    flex-direction: column;
    gap: 16px;
  }

  .storage-section {
    flex-direction: column;
    gap: 24px;
  }

  .storage-left {
    justify-content: space-between;
    width: 100%;
  }

  .storage-right {
    width: 100%;
    min-width: auto;
  }
}
</style>
